<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps<{
        currentRouteName: string | null;
    }>();

    const showNav = computed(() => {
        return props.currentRouteName === 'Events' || props.currentRouteName === 'EventSponsors' || props.currentRouteName === 'EventSpeakers';
    });
</script>

<template>
    <nav class="p-sm-t p-lg-r p-lg-l" v-if="showNav">
        <ul class="navbar-tabs list-unstyled d-inline-flex" role="tablist">
            <li :class="currentRouteName === 'Events' && 'active'">
                <router-link :to="{ name: 'Events' }">
                    {{ $Resources.EventsHeading }}
                </router-link>
            </li>
            <li :class="currentRouteName === 'EventSpeakers' && 'active'">
                <router-link :to="{ name: 'EventSpeakers' }">
                    {{ $Resources.EventSpeakersHeading }}
                </router-link>
            </li>
            <li :class="currentRouteName === 'EventSponsors' && 'active'">
                <router-link :to="{ name: 'EventSponsors' }">
                    {{ $Resources.SponsorHeading }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>
